<template>
  <v-container>
    <component  :is="'script'" type="application/ld+json">
      {
        "@context": "https://schema.org",
        "@type": "Article",
        "mainEntityOfPage":"https://hot-linux.dev/column",
        "headline":"Hot Linux ／ WEBシステム開発（日々のコラム）",
        "description":"Hot Linuxでは小規模WEBシステム開発やPHPプログラミングのアドバイスを中心にお引き受けしております。法人様だけでなく個人事業主様・個人様からの相談も大歓迎です。このページではプロが日々どのようなことを考えているのかを紹介しています。",
        "image":[
          "https://hot-linux.dev/img/hot-linux-logos_purple.de39c269.webp"
        ],
        "author":{
          "@type":"Person",
          "name":"山田昌史",
          "url":"https://hot-linux.dev/"
        }
      }
    </component>
    <v-row>
      <v-col cols="12" md="6">
        <left-side>
        </left-side>
      </v-col>
      <v-col cols="12" md="6">
        <v-breadcrumbs
          icon="mdi-calendar-month"
          bg-color="grey-lighten-4"
          rounded
        >
        <h3>日々のコラム</h3>
        </v-breadcrumbs>
        <template v-for='(row,index) in 新着情報rtn' :key='index'>
          <v-card class='mx-3 my-3' v-intersect="onIntersect" :data-src = "index">
            <template v-slot:title>
              <v-list>
                <v-list-item
                  :href="'https://google.com/search?q='+row.タイトル"
                  target="_blank"
                  style='white-space:normal'
                  >
                  {{日付書式(row.日付)}} {{row.タイトル}}
                </v-list-item>
              </v-list>
            </template>
            <!--
            <v-card-title>
              {{row.日付}} {{row.タイトル}}
            </v-card-title>
            -->
            <v-card-subtitle>
              {{row.分類}}
            </v-card-subtitle>
            <v-card-text>
              <span v-html='row.内容'></span>
            </v-card-text>
          </v-card>
          <!-- <div :data-src = "index" v-intersect="onIntersect" id="news">
          </div>-->
        </template>
        <infinite-loading @infinite="load">
        </infinite-loading>
      </v-col>
    </v-row>
    <!--
    <v-row>
      <v-col>
        <coconara-link class='d-block'></coconara-link>
      </v-col>
    </v-row>
    -->
  </v-container>

</template>

<script>
//import CoconaraLink from './CoconaraLink.vue'
import LeftSide from './LeftSide.vue'
import InfiniteLoading from 'v3-infinite-loading'
import "v3-infinite-loading/lib/style.css";
export default {
  //components: { LeftSide,CoconaraLink },
  components: { LeftSide,InfiniteLoading },
  data(){
    return {
      新着情報rtn:[],
      firstPage:0,
      totalCount:100,
      pageSize:10,
      nowPage:0
    }
  },

  computed:{
    日付書式(){
      return (日付) => {

        let targetDate = new Date(日付)
        //return targetDate

        let weekDayLabel = ["日","月","火","水","木","金","土"];
        //console.log(weekDayLabel)
        return targetDate.toLocaleDateString() + "("+ weekDayLabel[targetDate.getDay()]+")"
      }
    }
  },
  mounted(){
    let url = new URL(window.location.href);
    let params = url.searchParams;
    let targetPage = 0;
    if(params.get('page')){
      targetPage = params.get('page') - 1
    }else{
      targetPage = 0
    }
    
    this.nowPage = targetPage;
    //nowPageになるまで繰り返しロード

    //そこまでジャンプするのはどうするの？

  },
  methods:{
    load:async function($state){
      //this.$emit('overlay');

      let url = './api/api.php';
      let data = {
        func:"新着取得",
        page:this.nowPage,
        pageSize:this.pageSize,
      };

      let param = {
          method : "POST",
          headers : { "Content-Type": "application/json" },
          body : JSON.stringify(data),
          }

      try {
        const res = await fetch(url,param);
        const json = await res.json();

        let 新着情報rtn = json.新着情報rtn;
        this.totalCount = json.totalCount;
        if(新着情報rtn.length < this.pageSize){
          this.新着情報rtn.push(...新着情報rtn);
          $state.complete();
        }else{
          this.新着情報rtn.push(...新着情報rtn);
          $state.loaded();
        }
        //this.nowPage++;
      }catch(error){
        $state.error();
      }
      //this.$emit('overlay');
    },

    onIntersect:async function(isIntersecting,entries){
      let res = {
        'ratio' : entries[0].intersectionRatio>0,
        'dataSet' : Number(entries[0].target.attributes['data-src'].value)
      }
      if(res.ratio && res.dataSet){
        let nowPage = Math.floor(res.dataSet / this.pageSize) + 1 + this.firstPage
        let url_path = new URL(location.href)
        if(nowPage > 1){
          url_path.searchParams.set("page",nowPage)
        }else{
          url_path.searchParams.delete("page")
        }
        history.replaceState(null,null,url_path.toString());

        this.nowPage = nowPage
      }
    }
  },
}
</script>